import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faCircleExclamation, faCheckCircle, faInfoCircle } from '@fortawesome/pro-regular-svg-icons';

export enum NotificationLevel {
  Info = 'info',
  Success = 'success',
  Alert = 'alert',
  Error = 'error'
}

export const LevelIcon: Record<NotificationLevel, IconDefinition> = {
  [NotificationLevel.Info]: faInfoCircle,
  [NotificationLevel.Success]: faCheckCircle,
  [NotificationLevel.Alert]: faCircleExclamation,
  [NotificationLevel.Error]: faCircleExclamation
};
